import { useAppUpdate } from '../hooks/useAppUpdate'
import { useSignedIn } from '../hooks/useSignedIn'
import { UpdateBanner } from './UpdateBanner'
import { WhatsNewSheet } from './WhatsNewSheet'

/**
 * Mounted app-wide, so the service worker registers for every visitor; the
 * update prompt and What's new show only to someone signed in (onboarding
 * included), never on the landing or the login page.
 */
export function AppUpdater() {
  const signedIn = useSignedIn()
  const { updateAvailable, update, dismiss, whatsNew, dismissWhatsNew } = useAppUpdate(signedIn)

  return (
    <>
      <UpdateBanner open={updateAvailable} onUpdate={update} onDismiss={dismiss} />
      <WhatsNewSheet release={whatsNew} onClose={dismissWhatsNew} />
    </>
  )
}
